export default "__VITE_ASSET__Tp0BH6Hy__"